var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"tag":"router-link","to":_vm.routerPath}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v(_vm._s(_vm.iconName))])],1),_c('v-list-item-title',[_vm._v(_vm._s(_vm.itemTitle))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }